export enum ConfirmStatus {
    NOT_CONFIRMED = 100,
    CONFIRMED = 200,
    NOT_APPLICABLE = 300,
    PURCHASE_CLOSED = 400,
}
